import { trafficTotalSelector } from '@mm/state/selectors/websiteReportSummarySelector';
import { StoreState } from '@mm/state/store-interfaces';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import {
  BOOK_DEMO_ENTERPRISE,
  BOOK_DEMO_NON_ENTERPRISE,
  BOOK_NON_SQL_DISCO_CALL,
  ENTERPRISE_TRAFFIC_THRESHOLD,
  LLR_DEMO_UTM,
} from '../WebsiteReportSummary/constants';
import styles from './LLRActionButtons.module.css';

type Props = {
  buttonName?: string;
  className?: string;
  onClick: () => void;
  websiteURL: string;
};

export const LLRActionButtons = ({
  buttonName = 'Get Started Free',
  className,
  onClick,
  websiteURL,
}: Props) => {
  const totalTraffic = useSelector(trafficTotalSelector);
  const isSQL = totalTraffic.trafficTypes?.sql;
  const userGeodata = useSelector((state: StoreState) => state.userGeodata);

  const isElegibleForDemo = isSQL || userGeodata?.country_code === 'US';

  const trafficSum =
    (totalTraffic.trafficTypes?.organic || 0) +
    (totalTraffic.trafficTypes?.paid || 0);

  const demoUrl =
    trafficSum < ENTERPRISE_TRAFFIC_THRESHOLD
      ? `${BOOK_DEMO_NON_ENTERPRISE}?${LLR_DEMO_UTM(websiteURL)}`
      : `${BOOK_DEMO_ENTERPRISE}?${LLR_DEMO_UTM(websiteURL)}`;

  const discoUrl = `${BOOK_NON_SQL_DISCO_CALL}?${LLR_DEMO_UTM(websiteURL)}`;

  return (
    <div className={className}>
      <div className={styles.buttonsWrapper}>
        {buttonName && (
          <PrimaryButton
            onClick={onClick}
            className={classNames(styles.button, styles.buttonNew)}
          >
            {buttonName}
          </PrimaryButton>
        )}
        {isElegibleForDemo && (
          <PrimaryButton
            color="secondary-blue"
            className={classNames(styles.button, styles.bookDemoButton)}
            onClick={() => window.open(isSQL ? demoUrl : discoUrl)}
          >
            Book a Demo
          </PrimaryButton>
        )}
      </div>
      <div className={styles.text}>No credit card required.</div>
    </div>
  );
};
